import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestDiffusionModelsUDRent } from '@shared/dto/+diffusion_model/+ud/_requests/request_diffusion_models_ud_rent';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../_base/createAsyncThunkSafe';
import { StateMLAsset } from './state_ml_asset';

export const remote_ml_asset_rent = createAsyncThunkSafe(ENUM__network_event_client_to_server.ML_ASSET_RENT, async (request: RequestDiffusionModelsUDRent) => {
  await send_to_server(ENUM__network_event_client_to_server.ML_ASSET_RENT, request);
});

export function init_remote_ml_asset_rent_or_prolongate(builder: ActionReducerMapBuilder<StateMLAsset>) {
  builder
    .addCase(remote_ml_asset_rent.pending, (state, action) => {})
    .addCase(remote_ml_asset_rent.rejected, (state, action) => {})
    .addCase(remote_ml_asset_rent.fulfilled, (state, action: PayloadAction<void>) => {});
}
